import { Component, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'empty-layout',
  templateUrl: './empty.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class EmptyLayoutComponent implements OnDestroy {
  dir = 'ltr';

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _translateService: TranslocoService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    // language
    this.document.documentElement.lang = this._translateService.getActiveLang();
    if (this._translateService.getActiveLang() === 'ar') {
      this.document.documentElement.dir = 'rtl';
      this.document.body.classList.add('rtl');
      this.dir = 'rtl';
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
